import { Button, Text, Group, Container, Stack, Input, Table, Box, Title } from '@mantine/core';
import classes from './itinerary-modal.module.css';

function IntakeModal({ onClose }: { onClose: () => void }) {
  const rowTitles5 = [
    'Are there specific foods you prefer?',
    'List specific types of attractions you most enjoy (e.g., Scenic)?',
    'List specific types of activities you most enjoy (e.g., Hiking)',
    'List specific people, places & things you wish to avoid (e.g., Crowds)',
  ];
  const placeholders = ['first', 'second', 'third', 'forth', 'fifth'];

  const rows5 = () =>
    rowTitles5.map((title) => (
      <Table.Tr key={title}>
        <Table.Td>{title}</Table.Td>
        {Array.from({ length: 5 }).map((_, index) => (
          <Table.Td c="red.5" key={`${title}-${index}`}>
            <Input classNames={{ input: classes.input }} placeholder={placeholders[index]} />
          </Table.Td>
        ))}
      </Table.Tr>
    ));

  const rowTitles = [
    'What places have you liked / disliked with previous travel?',
    'What do you wish most to get out of this trip?',
    'Any other comments / concerns or special needs?',
  ];
  const rows = () =>
    rowTitles.map((title) => (
      <Table.Tr key={title}>
        <Table.Td>
          <Text>{title}</Text>
        </Table.Td>
        <Table.Td colSpan={5}>
          <Input classNames={{ input: classes.input }} />
        </Table.Td>
      </Table.Tr>
    ));

  return (
    <Container fluid>
      <Box bg="var(--mantine-color-voyTitleBox-6)" p={10} mb={30} mt={0}>
        <Title order={2} c="white" ta="center">
          Personalized Trip Preferences
        </Title>
      </Box>

      <Stack>
        <Text>
          Please provide us with some information about your travel preferences. This will help us create a personalized
          itinerary for you. The more information you provide, the better we can tailor your trip to your needs.
        </Text>
        <Table w="100%">
          <Table.Thead>
            <Table.Tr>
              <Table.Th w={300} />
              <Table.Th>1</Table.Th>
              <Table.Th>2</Table.Th>
              <Table.Th>3</Table.Th>
              <Table.Th>4</Table.Th>
              <Table.Th>5</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows5()}
            {rows()}
          </Table.Tbody>
        </Table>
      </Stack>
      <Group justify="flex-end" mt={20}>
        <Button onClick={onClose} mt={20} color="red">
          Cancel
        </Button>
        <Button onClick={onClose} mt={20}>
          Save
        </Button>
      </Group>
    </Container>
  );
}

export default IntakeModal;
